module.exports = __webpack_public_path__ + "img/AbdulkhaliqYa3qubi-Nali.e67da19a.jpg";